import { useState } from "react";
import Logo from "../assets/Logo.svg";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import VerifyModel from "./model";
import "../App.css";

const SNavbar = ({ actionBTN, title, path }) => {
  const [modalShow, setModalShow] = useState(false);
  const handleClick = () => {
    if (path === "/booking") {
      setModalShow(true);
    }
  };
  return (
    <div className="Navbar-main-container second-main-navbar">
      <Navbar collapseOnSelect expand="lg" className=" navbar">
        <Container className=" w-100 px-0  ">
          <Navbar.Collapse id="responsive-navbar-nav">
            <Link
              to={path}
              className="Navbar-cross-link"
              sm={1}
              onClick={handleClick}
            >
              {actionBTN}
            </Link>

            <Nav className="me-auto">
              <Nav.Link href="" className="nav-cross-link">
                {title}
              </Nav.Link>
            </Nav>
            <Navbar.Brand href="/" className="nav-logo">
              <img src={Logo} alt="RogerBooking logo" />
            </Navbar.Brand>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <VerifyModel show={modalShow} onHide={() => setModalShow(false)} />
    </div>
  );
};

export default SNavbar;
